/***********************************
  General Content Module
************************************/

Quad.GeneralContent = ( function() {


  // PRIVATE VARS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~


  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  function _init() {

    var isMobile = false;
    if ( /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test( navigator.userAgent )
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test( navigator.userAgent.substr( 0, 4 ))) {
      isMobile = true;
    }

    $( 'video' ).each( function() {
      isMobile && $( this ).hasClass( 'loop' ) ? $( this ).css( 'left', '-66.666%' ) : $( this ).attr( 'src', $( this ).attr( 'data-src' ));
    });

    $('.wp-block-embed-youtube iframe').each(function(){
      var src = $(this).attr('src');
      $(this).attr('src',src+'&rel=0');
    });

    $( '.tile a' ).hover( function() {
        $( this ).parents( '.tile' ).addClass( 'hover' );
      }, function() {
        $( this ).parents( '.tile' ).removeClass( 'hover' );
    });

    $.fn.equalHeight = function() {
      var maxHeight = -1;
      $( this ).each( function() {
        $( this ).outerHeight() > maxHeight ? maxHeight = $( this ).outerHeight() : maxHeight = maxHeight;
      });
      $( this ).outerHeight( maxHeight );
    };
    $( '.home-case-studies .tile div' ).equalHeight();
    $( '.case-study.tile' ).equalHeight();
    $( 'article.brand-teaser' ).equalHeight();
    $( '.result' ).equalHeight();
    $( '.user-type' ).equalHeight();
    $( '.match-height' ).equalHeight();

    if ( $( '.page-header h1' ).text().indexOf( ':' ) > 1 ) {
      var str = $( '.page-header h1' ).text().split( ':' ).pop();
      var newText = $( '.page-header h1' ).text().replace( str, '<span>'+str+'</span>' );
      $( '.page-header h1' ).html( newText );
    }

    $( '.trigger-search-menu' ).click( function() {
      $( '.main-nav-btn[data-menu="search"]' ).trigger( 'click' );
      $( '#search-input' ).focus();
    });

    if ( $( '.page-header' ).hasClass( 'with-video' )) {
      $( '.page-header .btn' ).attr( 'href', '#' );
    }

    $( '.page-header.with-video .btn' ).click( function( e ) {
      e.preventDefault();
      $( '.page-header' ).addClass( 'transitioning' );
      function tweenDataHeight() {
        var dataHeight = $( '.page-header' ).data( 'height' ) + 8;
        new TimelineMax()
          .to( $( '.page-header' ), 0.2, { height: dataHeight, ease: Sine.easeOut });
      }
      new TimelineMax()
        .add( function() {
          var dataSrc = $( '.page-header .header-video' ).data( 'src' );
          $( '.page-header .header-video' ).attr( 'src', dataSrc );
          var vWidth, vHeight;
          $( '.page-header .header-video' ).bind( 'loadedmetadata', function() {
            vWidth = this.videoWidth;
            vHeight = this.videoHeight;
            var aspectRatio = vWidth / vHeight;
            var vw = ( $( window ).width() / 17 ) * 16;
            var column = $( window ).width() / 17;
            var vh = ( vw / aspectRatio ); // - ( column * 1.5 );
            $( '.page-header' ).attr( 'data-height', vh );
            $( '.page-header' ).attr( 'data-init-height', $( '.page-header' ).outerHeight());
          });
          if ( $( '.header-video' ).length ) {
            vWidth = document.querySelector( '.header-video' ).videoWidth;
            vHeight = document.querySelector( '.header-video' ).videoHeight;
            var aspectRatio = vWidth / vHeight;
            var vw = ( $( window ).width() / 17 ) * 16;
            var column = $( window ).width() / 17;
            var vh = ( vw / aspectRatio ) - ( column * 1.5 );
            $( '.page-header' ).attr( 'data-height', vh );
            $( '.page-header' ).attr( 'data-init-height', $( '.page-header' ).outerHeight());
          }
        })
        .to( '.page-header .header-content', 0.2, { opacity: 0 })
        .add( function() {
 tweenDataHeight();
})
        .set( '.page-header .header-video-outer', { display: 'block', opacity: 0 }, '0.5' )
        .to( '.page-header .header-video-outer', 0.2, { opacity: 1, delay: 0.2 });
    });

    $( '.page-header.with-embed .btn' ).click( function( e ) {
      e.preventDefault();
      $( '.page-header' ).addClass( 'transitioning' );

      var embedHeight;
      window.innerWidth >= 767 ? embedHeight = '53.5vw' : embedHeight = '57vw';

      new TimelineMax()
        .add( function() {
          $( '.page-header' ).attr( 'data-init-height', $( '.page-header' ).outerHeight());
        })
        .to( '.page-header', 0.2, { height: embedHeight })
        .to( '.page-header .header-content', 0.2, { opacity: 0 })
        .set( '.page-header .header-video-outer', { display: 'block', opacity: 0 }, '0.5' )
        .to( '.page-header .header-video-outer', 0.2, { opacity: 1, delay: 0.2 })
        .to( '.close-modal', 0.35, { opacity: 1 });
    });

    $( '.close-modal' ).click( function() {

      var iframe = document.querySelector( '.header-video' );
      if ( iframe ) {
        var player = new Vimeo.Player( iframe );
        player.pause();
      }
      function rollBackDataHeight() {
        var dataHeight = $( '.page-header' ).data( 'init-height' );
        new TimelineMax()
          .to( $( '.page-header' ), 0.2, { height: dataHeight, ease: Sine.easeOut });
        setTimeout( function() {
          $( '.page-header' ).removeClass( 'transitioning' );
        }, 250 );
      }

      new TimelineMax()
        .to( '.close-modal', 0.35, { opacity: 0 })
        .to( $( '.page-header .header-video-outer' ), 0.2, { opacity: 0 }, '-=0.35' )
        .add( function() {
 rollBackDataHeight();
})
        .set( $( '.page-header .header-video-outer' ), { display: 'none' })
        .to( '.page-header .header-content', 0.2, { opacity: 1 });

    });

    $( window ).resize( function() {

      //$('.hero, .slide').css('height','');
      $( '.home-case-studies .tile div' ).css( 'height', '' ).equalHeight();
      $( 'article.brand-teaser' ).css( 'height', '' ).equalHeight();
      $( 'article.user-type' ).css( 'height', '' ).equalHeight();
      $( '.case-study.tile' ).css( 'height', '' ).equalHeight();
      $( '.menu-search-result' ).css( 'height', '' ).equalHeight();
      $( '.match-height' ).css( 'height', '' ).equalHeight();

      if ( $( '.header-video' ).length ) {
        var vWidth = document.querySelector( '.header-video' ).videoWidth;
        var vHeight = document.querySelector( '.header-video' ).videoHeight;
        var aspectRatio = vWidth / vHeight;
        var vw = ( $( window ).width() / 17 ) * 16;
        var column = $( window ).width() / 17;
        var vh = ( vw / aspectRatio ) - ( column * 1.5 );
        $( '.page-header.with-video' ).height( vh );
        $( '.page-header.with-video' ).attr( 'data-height', vh );
        $( '.page-header.with-video' ).attr( 'data-init-height', $( '.page-header' ).outerHeight());
      }

      if ( window.innerWidth >= 767 && window.innerWidth <= 1280 ) {

        $( '.page-header.with-embed' ).hasClass( 'transitioning' ) ? $( '.page-header.with-embed' ).attr( 'data-init-height', '36vw' ) : $( '.page-header.with-embed' ).css( 'height', '36vw' ).attr( 'data-init-height', '36vw' );

      } else if ( window.innerWidth >= 767 && window.innerWidth >= 1280 ) {

        $( '.page-header.with-embed' ).hasClass( 'transitioning' ) ? $( '.page-header.with-embed' ).attr( 'data-init-height', '33vw' ) : $( '.page-header.with-embed' ).css( 'height', '33vw' ).attr( 'data-init-height', '33vw' );

      } else {

        $( '.page-header.with-embed' ).hasClass( 'transitioning' ) ? $( '.page-header.with-embed' ).attr( 'data-init-height', '75vw' ) : $( '.page-header.with-embed' ).css( 'height', '75vw' ).attr( 'data-init-height', '75vw' );

      }

    });

    $( '.pardot-form iframe' ).on('load', function(){

      iFrameResize({ log: true }, '.pardot-form iframe' );

    });

    // IR Footer

    var investorFooter = $('#investor-footer .statement');
    if( investorFooter ){
      var invParsed = investorFooter.prop('innerHTML');
      if( invParsed ){
        var morePos = invParsed.indexOf('<!--more-->');
        if( morePos > -1 ){
          String.prototype.insertAt = function(index, string){ return this.substr(0, index) + string + this.substr(index); }
          var preDiv = invParsed.insertAt( morePos, '<div class="readmore">' );
          var postDiv = preDiv + '</div><button id="ir-footer-read-more"><span class="icon icon-down-circle"></span>Read <span class="more">more</span><span class="less">less</span></button>';
          $( investorFooter ).html( postDiv );
          
          if( window.innerWidth < 767 ){
            $( '#investor-footer .readmore' ).hide();
          }
          
        }
      }
    }

    $( document ).on( 'click', '#ir-footer-read-more', function(){
      $( '#investor-footer .readmore' ).slideToggle();
      $(this).toggleClass('opened');
    });

  }

  // PUBLIC METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  return {

    init: _init

  };

})();